"use strict";

import angular from "angular";

import _ from "lodash";
import { Accounting } from "../../../gateway/Accounting/Accounting";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";
import unauthorizedDialogTemplate from "./dialogs/unauthorized/unauthorized.html";
import upgradeContractDialogTemplate from "./dialogs/upgrade-contract/upgrade-contract.html";

export class ContractAccountingService {
    constructor($stateParams, $rootScope, $state, DSNDialogService, $mdDialog) {
        this.accountingId = _.get($stateParams, "accountingId");

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.$stateParams = $stateParams;

        this.Accounting = new Accounting();
        this.Events = new Events();
        this.User = new User();

        this.userData = new UserDataAdapter().user();

        this.isContract = false;
        this.accounting = null;

        this.bindings = { _id: 1, contract: 1, plan: 1, analytics: 1 };
    }

    async startSideNavContract() {
        this.userData = new UserDataAdapter().user();
        const accounting = await this.Accounting.getById(
            this.accountingId || this.$stateParams.accountingId
        );
        this.accounting = accounting;
    }

    async startContract(permissions = [], source = false) {
        this.userData = new UserDataAdapter().user();

        const permArray = [].concat(permissions);

        this.source = source;

        if (this.accounting) {
            this.isContract = permArray.includes(
                _.get(this.accounting, "contract")
            )
                ? true
                : false;
            return;
        }
        const accounting = await this.Accounting.getById(
            this.accountingId || this.$stateParams.accountingId
        );
        this.isContract = permArray.includes(accounting?.contract)
            ? true
            : false;
        this.accounting = accounting;
    }

    setAccounting(accountingId) {
        this.accountingId = accountingId;
    }

    setAccountingDocument(accounting) {
        this.accounting = accounting;
    }

    setUser(user) {
        this.userData = user;
    }
    /**
     * @public
     * Verificar se a contabilidade possui permissão
     * @param {Array<String> | String} permissions
     * @param {String} source
     * @returns {Boolean}
     */
    hasContract(permissions) {
        const permissionArray = [].concat(permissions);
        if (permissionArray.includes(_.get(this.accounting, "contract")))
            return true;
        return false;
    }

    /**
     * @public
     * Executa o callbac caso a contabilidade tenha o determinado contrato
     * @param {Array<String> | String} permissions
     * @param {function} eventCallback
     * @param {String} conditionSource
     * @returns {Promise<function> | Boolean}
     */
    has(permissions, eventCallback) {
        if (
            this.source !==
            SourceConvert.toSystem(_.get(this.$state, "params.source"))
        )
            return eventCallback(this.accounting);
        this._contractCallback(permissions, eventCallback);
    }

    /**
     * @private
     * @param {Array<String> | String} permissions
     * @param {function} eventCallback
     * @returns {Promise<function> | Boolean}
     */
    async _contractCallback(permissions, eventCallback) {
        const perms = [].concat(permissions);
        if (this.accounting) {
            if (perms.includes(this.accounting?.contract)) {
                this.isContract = true;
                return eventCallback(this.accounting);
            } else return false;
        }
        const accounting = await this.Accounting.getById(this.accountingId);
        this.accounting = accounting;
        if (perms.includes(accounting.contract)) {
            this.isContract = true;
            return eventCallback(accounting);
        }
        return false;
    }

    /**
     * @public
     * Solicitar upgrade na conta contabilidade
     */
    request = async ($event = {}) => {
        await this.startSideNavContract();

        if (
            !this.User.checkPermission({
                roles: _.get(this.userData, "roles"),
                granted: ["Contabilidade"]
            })
        )
            return this._onUnauthorizedDialog($event);

        this.Events.send("Solicitar.Mudanca.Plano");
        this.DSNDialogService.custom({
            controller: "UpgradeContractCtrl",
            targetEvent: $event,
            clickOutsideToClose: true,
            locals: {
                title: "",
                accounting: this.accounting,
                width: "80%",
                templateHtml: upgradeContractDialogTemplate
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    };

    _onUnauthorizedDialog($event) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            targetEvent: $event,
            controller: "UnauthorizedDialogCtrl",
            locals: {
                title: "",
                width: "467px",
                templateHtml: unauthorizedDialogTemplate
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }
}

angular
    .module("nucont.shared")
    .service("ContractAccounting", [
        "$stateParams",
        "$rootScope",
        "$state",
        "DSNDialogService",
        "$mdDialog",
        ContractAccountingService
    ]);
